<template>
    <div >
        <modalreal  :zIndexEdit='true'>
            <!-- 标题插槽 -->
            <div slot="title">{{$t('message.可用接口')}}</div>
            <!-- 搜索框插槽 -->
            <div slot="serch"></div>
            <!-- 内容区插槽 -->
            <div slot="contner">
                <div class="remark">
                <p>{{$t('message.划线的为不可用接口若要使用请联系客户经理')}}</p>
            </div>
            <div class="datatable">
                <el-table :data="data" border :cell-class-name='"nonpad"'>
                    <el-table-column :label="$t('message.模块')" width="150" align="center" >
                        <template slot-scope="scope">
                           <div class="pdf">{{$i18n.locale=='cn'?scope.row.name:scope.row.nameEng}}</div>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('message.接口')" width="350" align="center" >
                        <template slot-scope="scope">
                            <div v-for="(item,index) in scope.row.dataList" :key='item.name' class="pdf">
                                <div :class="index==(scope.row.dataList.length-1)?'':'border'" :style="item.open?'':'text-decoration:line-through'">{{$i18n.locale=='cn'?item.data.chinese:item.data.english}}</div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('message.速流限制')" width="200" align="center" >
                        <template slot-scope="scope">
                            <div v-for="(item,index) in scope.row.dataList" :key='item.name' class="pdf">
                                <div :class="index==(scope.row.dataList.length-1)?'':'border'" >
                                    <div v-if="item.open">
                                        <span style="color:red">
                                        {{item.days+$t('message.天')}}</span>
                                        {{$t('message.最大调取')}}
                                        <span style="color:red">{{item.limit+$t('message.次')}}</span>
                                    </div>
                                        <div v-else> 
                                            <span>-/-</span>
                                        </div>
                                    </div>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column :label="$t('message.已调取次数')" width="250" align="center" >
                        <template slot-scope="scope">
                            <div v-for="(item,index) in scope.row.dataList" :key='item.name' class="pdf">
                                <div v-if="item.open">
                                <div :class="index==(scope.row.dataList.length-1)?'':'border'">{{item.calls+'/'+item.left}}</div>
                                    </div>
                                        <div v-else> 
                                            <span>-/-</span>
                                        </div>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            </div>
            <!-- 底部区插槽 -->
            <div slot="foter" class="foter">
                <el-button type="" @click="outff" icon="el-icon-close" round size="mini" >{{$t('message.好的')}}</el-button>
            </div>
        </modalreal>
    </div>
</template>
<script>
import modalreal from '@/components/modalCom/modalreal'
import {rejecthttp,changeflagCLOSED} from "@/utils/request";
export default {
    name:'plattable',
    components:{
        modalreal
    },
    data(){
        return{
            data:[]
        }
    },
    methods:{
        outff(){
            this.$emit('outff')
        },
        refresh(){
            rejecthttp(false,'get',"/manage/openapi/openapilimit",{
              appid:188
          },this,(doc) => {
    		        changeflagCLOSED(doc,0,this)
    		        if(doc.data.Code == "MSGKEY_OK"){
    		          console.log(doc.data);
                        this.data=doc.data.data
    		        }
    		        })
        }
    },
    mounted(){
        this.refresh()
    }
}
</script>
<style  scoped>
    .foter{
        text-align: right;
    }
    .shade-chil {
  width: 1050px;
  height: 680px;
  /* background-color: RGB(249,249,249); */
  border-radius: 12px;
  box-shadow: 4px 4px 12px #888888;
  background-image: linear-gradient(#f9f9f9, #fdfdfd, #f0f0f0, #f3f3f3);
  border-left: 1px solid #bbb;
  border-top: 1px solid #bbb;
  border-right: 1px solid #888;
  border-bottom: 1px solid #888;
  padding: 20px;
  position: relative;
  z-index: 100;
  -moz-user-select: none;
  -o-user-select: none;
  -khtml-user-select: none;
  -webkit-user-select: none;
  -ms-user-select: none;
  user-select: none;
    }
    .flr{
        float: right;
        cursor: pointer;
        font-weight: 600;
    }
    .flr:hover{
        color: black;
    }
    .remark{
        margin: 10px 0 30px 0;
    }
    .content{
        padding: 20px;
    }
    .datatable{
        height: auto;
    }
    .footer{
        text-align: right;
        margin: 0 30px;
    }
    .border{
        border-bottom: 1px solid #EBEEF5;
        line-height: 32px;
        height: 32px;
    }
    .datatable /deep/ td{
        padding: 0;
    }
   .datatable /deep/ .el-table .cell {
        padding: 0;
    }
    .nonpad{
        padding: 0;
    }
    .pdf{
        padding: 10px 0 10px 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/settings/plattable.vue